// src/api/config.js
const API_BASE = process.env.REACT_APP_API_BASE || 'https://trendmix-backend-service-864903803368.asia-northeast3.run.app';
// const API_BASE = 'http://localhost:8000';
const API_VERSION = process.env.REACT_APP_API_VERSION || 'v1';
const API_URL = `${API_BASE}/api/${API_VERSION}`;
const S3_URL = process.env.REACT_APP_S3_URL || 'https://trendmix.s3.ap-southeast-1.amazonaws.com';

export const API_URLS = {
  BASE: API_BASE,
  API: API_URL,
  S3: S3_URL
};

export default API_URLS; 